import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ButtonWithFontAwesome from '../Buttons/ButtonWithFontAwesome';
import { FONT_GSS_FUTURA_BOOK } from '../../../themes/defaultTheme';

type BasicModalProps = {
  leftButtonAction?: () => void;
  rightButtonAction?: any;
  headerText?: string;
  headerFontSize?: string;
  leftButtonText?: string;
  leftButtonIcon?: React.ReactNode;
  rightButtonText?: string;
  rightButtonIcon?: React.ReactNode;
  rightButtonStyle?: React.CSSProperties;
  rightButtonClass?: string;
  rightButtonProps?: any;
  leftButtonProps?: any;
  children?: React.ReactNode;
};

type StylesProps = {
  headerFontSize?: string;
};

// This is just a white modal with text and two buttons
const BaseMatManModal = ({
  leftButtonAction,
  rightButtonAction,
  headerText,
  headerFontSize = '28px',
  leftButtonText,
  leftButtonIcon,
  rightButtonText,
  rightButtonIcon,
  rightButtonStyle,
  rightButtonClass,
  leftButtonProps,
  rightButtonProps,
  children,
}: BasicModalProps) => {
  const classes = useStyles({ headerFontSize });
  return (
    <Box className={classes.modal}>
      <Box style={{ textAlign: 'center', padding: '24px', width: '100%' }}>
        <Box style={{ textAlign: 'left' }}>
          {headerText && (
            <Typography className={classes.title} variant="h5">
              {headerText}
            </Typography>
          )}
          {children}
        </Box>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            paddingTop: '30px',
          }}
        >
          <ButtonWithFontAwesome
            onClick={leftButtonAction}
            text={leftButtonText}
            aria-label={leftButtonText}
            startIcon={leftButtonIcon}
            color="primary"
            variant="outlined"
            {...leftButtonProps}
          />{' '}
          <ButtonWithFontAwesome
            onClick={rightButtonAction}
            text={rightButtonText}
            startIcon={rightButtonIcon}
            aria-label={rightButtonText}
            color="primary"
            variant="contained"
            style={rightButtonStyle}
            className={rightButtonClass}
            {...rightButtonProps}
          />
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    flex: 1,
    backgroundColor: 'white',
    width: '600px',
    justifyContent: 'center',
  },
  title: {
    fontSize: (props: StylesProps) => props?.headerFontSize,
    marginBottom: '20px',
  },
  body: {
    fontFamily: FONT_GSS_FUTURA_BOOK,
    fontSize: '18px',
    lineHeight: '24px',
  },
}));

export default BaseMatManModal;
